export enum TemperatureBySensorColumn {
  Date = 'occurredAt',
  RegNo = 'regno',
  Vehicle = 'vehicle',
  Temperature = 'temperature',
  Humidity = 'humidity',
  LightStatus = 'ambientLightStatus',
  Position = 'position',
}
